import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface UpdateImportRowRequestModel {
	readonly importRowId: string;
	readonly quantityText: string;
	readonly fcIdText: string;
	readonly actionText: string;
	readonly unitAmountText: string;
	readonly currencyText: string;
	readonly dateText: string;
}

export const useUpdateImportRow = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, UpdateImportRowRequestModel> = async requestModel => {
		return http<undefined, UpdateImportRowRequestModel>({
			method: "PUT",
			url: `/import-row/${requestModel.importRowId}`,
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["importStatus"] });
		}
	});
};
